import ConditionReportSearchModel from "@/modules/condition-reports/ConditionReportSearch.model";
import _ from "lodash";
import ConditionReportImagesService from "@/modules/condition-report-images/ConditionReportImagesService";
import AttachmentService from "@/modules/attachments/AttachmentService";

let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new ConditionReportSearchModel(),
    sale: null,
    extraFilters: {}
  }
};

export default {
  namespaced: true,
  state: {
    imagesModal: {
      show: false,
      object: null,
      source: null
    },
    tableData: {
      condition_images: getDefaultTableData()
    },
    viewModal: {
      show: false,
      file: null
    }
  },
  actions: {
    showConditionReportImageModal({commit}, {object = null, source} = {}) {
      commit('showConditionReportImageModal', {object: _.cloneDeep(object), source});
    },
    async hideConditionReportImageModal({commit}) {
      commit('hideConditionReportImageModal');
    },
    async getConditionReportImages({commit}, item) {
      let response = await ConditionReportImagesService.getConditionReportImages(item.uuid, 'created_by', '');
      if (response.success) {
        commit('updateConditionImagesTableData', {
          rows: response.body,
        });
      }
      return response;
    },
    async deleteConditionReportImage({state}, payload) {
      let response = await ConditionReportImagesService.removeConditionReportImage(payload)
      if (response.success) {
        state.tableData['condition_images'].rows = state.tableData['condition_images'].rows.filter(item => item.uuid !== payload);
      }
      return response;
    },
    async createConditionReportImage({state}, {formData, onUploadProgress}) {
      let response = await ConditionReportImagesService.createConditionReportImages(formData, onUploadProgress)
      if (response.success) {
        response.body.forEach(item => state.tableData['condition_images'].rows.unshift(item));
        state.tableData['condition_images'].rows = [...state.tableData['condition_images'].rows]
      }
      return response;
    },
  },
  mutations: {
    showConditionReportImageModal: (state, {object, source}) => {
      state.imagesModal.show = true;
      state.imagesModal.object = object;
      state.imagesModal.source = source;
    },
    hideConditionReportImageModal: (state) => state.imagesModal.show = false,
    updateConditionImagesTableData: (state, payload) => state.tableData['condition_images'] = {...state.tableData['condition_images'], ...payload },
  }
}
